import { useState, useEffect } from 'react';

export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-white via-gray-50 to-white">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, #72BF3B 1px, transparent 1px)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      {/* Animated Gradient Orbs - Ajustados para mobile */}
      <div className="absolute top-20 left-10 w-96 h-96 bg-[#72BF3B] rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse hidden md:block"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#99D93B] rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse delay-1000 hidden md:block"></div>
      
      {/* Orbs menores para mobile */}
      <div className="absolute top-10 -left-20 w-48 h-48 bg-[#72BF3B] rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse md:hidden"></div>
      <div className="absolute bottom-10 -right-20 w-48 h-48 bg-[#99D93B] rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse delay-1000 md:hidden"></div>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center w-full pt-24 md:pt-0">
        <div className="inline-flex items-center space-x-2 bg-[#72BF3B]/10 backdrop-blur-sm px-5 py-2 rounded-full border border-[#72BF3B]/30 mb-8">
          <i className="ri-sparkling-line text-[#72BF3B]"></i>
          <span className="text-sm font-medium text-[#162840]">Parceiro Oficial Bitrix24</span>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-[#162840] mb-8 leading-tight">
          Transforme seu negócio<br />
          com <span className="bg-gradient-to-r from-[#72BF3B] to-[#99D93B] bg-clip-text text-transparent">tecnologia inteligente</span>
        </h1>

        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-[#162840]/70 max-w-3xl mx-auto mb-12 leading-relaxed px-4">
          Automação, integração e inteligência artificial para empresas que buscam mais produtividade, controle e crescimento sustentável
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16 md:mb-0">
          <button 
            onClick={() => scrollToSection('contact')}
            className="bg-[#72BF3B] text-white px-8 py-4 rounded-xl text-lg font-semibold hover:bg-[#99D93B] transition-all shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            Começar Agora
          </button>
          <button 
            onClick={() => scrollToSection('about')}
            className="bg-[#162840]/5 backdrop-blur-sm text-[#162840] px-8 py-4 rounded-xl text-lg font-semibold hover:bg-[#162840]/10 transition-all border border-[#162840]/20 cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            Saiba Mais
          </button>
        </div>
      </div>

      {/* Scroll Indicator - Ajustado para não ficar atrás dos botões */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce z-0">
        <i className="ri-arrow-down-line text-3xl text-[#72BF3B]"></i>
      </div>
    </section>
  );
}
